import { TrevorIcon, TrevorIconName } from '../TrevorIcon';
import styled from 'styled-components';
import { FC } from 'react';
import { Body } from '../TypographyNew';
import React from 'react';

export type IconBulletListProps = {
  iconName: TrevorIconName;
  bullets: string[];
};

const IconBulletListContainer = styled.div`
  display: flex;

  > ul {
    padding-left: 32px;
    margin: unset;
    color: var(--color-interface-content-normal);
    text-align: start;
  }
`;
export const IconBulletList: FC<IconBulletListProps> = ({
  iconName,
  bullets,
}) => {
  return (
    <IconBulletListContainer>
      <TrevorIcon name={iconName} size={'xl'} />
      <ul>
        {bullets.map((bullet) => (
          <li key={bullet}>
            <Body variant={1}>{bullet}</Body>
          </li>
        ))}
      </ul>
    </IconBulletListContainer>
  );
};
